import React, { Component } from 'react';
import './style.css';
import logo from './logo.png';
import logoSmall from './logo_small.png';
import { Link } from 'react-router-dom';
import { Watch } from 'scrollmonitor-react';


export default Watch(class Header extends Component {
	landingPage = 1;

	componentDidUpdate() {
		this.landingPage = document.querySelector('.landing');
	}
	constructor(props) {
		super(props);
		this.state = { isActive: false };
	}

	render() {
		let model = {
			data: {
				title: [
					{
						text: ''
					}
				],
				subtitle: ''
			}
		}
		let about = model;
		let services = model;
		let bio = model;
		let contact = model;
		let client = model;
		let testimonial = model;

		if (this.props.content.length > 0) {
			about = this.props.content.find(e => { return e.type === 'about' });
			services = this.props.content.find(e => { return e.type === 'services' });
			bio = this.props.content.find(e => { return e.type === 'didierdegreef' });
			contact = this.props.content.find(e => { return e.type === 'contact' });
			client = this.props.content.find(e => { return e.type === 'clients' });
			testimonial = this.props.content.find(e => { return e.type === 'testimonials' });
		}

		if (this.props.isInViewport && this._headerContainer.classList.contains('fixed')) {
			this._headerContainer.classList.remove('fixed');

		} else if (this.props.isAboveViewport && !this._headerContainer.classList.contains('fixed')) {
			this._headerContainer.classList.add('fixed');


		}

		return (
			<header className="header" id="home">
				<header className="wrapper" ref={(el) => { this._headerContainer = el; }}>
					<nav className={this.state.isActive ? "navigation active" : "navigation"}>
						<a className="logo" href="http://erudis.be"><img src={logoSmall} alt="website's logo" /></a>

						<ul className="language-list">
							<li><Link to="/fr" className={this.props.lang === 'fr-be' ? 'active' : ''}>FR</Link></li>
							<li><Link to="/nl" className={this.props.lang === 'nl-be' ? 'active' : ''}>NL</Link></li>
							<li><Link to="/en" className={this.props.lang === 'en-gb' ? 'active' : ''}>EN</Link></li>
						</ul>
						<button className="navigation-btn" onClick={(el) => { this.toggleNavigation() }}><span></span></button>
						<ul className="navigation-list" onClick={this.toggleNavigation.bind(this)}>
							<li className="navigation-list__item">
								<a href="#home">Home</a>
							</li>
							<li className="navigation-list__item">
								<a href="#about">{about.data.title[0].text}</a>
								<span>{about.data.subtitle}</span>
							</li>
							<li className="navigation-list__item">
								<a href="#services">{services.data.title[0].text}</a>
								<span>{services.data.subtitle}</span>
							</li>
							<li className="navigation-list__item">
								<a href="#testimonials">{testimonial.data.title[0].text}</a>
							</li>
							<li className="navigation-list__item">
								<a href="#clients">{client.data.title[0].text}</a>
								<span>{client.data.subtitle}</span>
							</li>
							<li className="navigation-list__item">
								<a href="#bio">{bio.data.subtitle}</a>
								<span>Didier de Greef</span>
							</li>
							<li className="navigation-list__item">
								<a href="#contact">Contact</a>
								<span>{contact.data.subtitle}</span>
							</li>
						</ul>
					</nav>
					<div className="header__banner">
						<h1 className="stie-title visuallyhidden">Erudis Consulting</h1>
						<a href="http://erudis.be"><img src={logo} alt="website's logo" /></a>
					</div>
				</header>
			</header>
		);
	}

	toggleNavigation() {
		this.setState(prevState => ({
			isActive: !prevState.isActive
		}))
	}
});


// WEBPACK FOOTER //
// ./src/components/header/index.js